
<label> From &nbsp;</label>
<input class="date-input-styled" type="date"  min="2022-01-01" [max]="maxDate"  [(ngModel)]="startDate" >
<label class="ml-2rem"> To &nbsp;</label>
<input class="date-input-styled" type="date"  min="2022-01-01" [max]="maxDate"  [(ngModel)]="endDate" >
<button class="ml-10px mb-1rem mybutton" (click)="submit()">Submit</button>

